<template>
    <cmp-proj-graph 
        ref="list"
        header-text="案件分析"
        >
        <div v-if="getListObj">
            <div v-if="getListObj.data.length > 0">
                <div class="card mb-2">
                    <ul class="list-group list-group-flush">
                        <li v-for="item in getListObj.data" :key="item.id" class="list-group-item p-1 let-space-1">
                            <div class="d-flex align-items-center">
                                <span>
                                    <small class="text-munted">({{item.cnt}}/{{item.all_cnt}})</small>
                                </span>
                                <span class="text-truncate">
                                    <small>{{item.name}} </small>
                                </span>
                                <span class="flex-fill text-right">
                                    <small> {{item.user_group}} </small>
                                </span>
                            </div>
                            <div class="progress-bar" role="progressbar" :style="{width:item.percent + '%'}" :aria-valuenow="item.percent" aria-valuemin="0" aria-valuemax="100">{{item.percent}}%</div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </cmp-proj-graph>
</template>

<script>
    import CmpProjGraph from 'pages/commons/List/List'
    import {mapGetters} from 'vuex'

    export default {
        components: {
            CmpProjGraph
        },
        mounted () {
            this.$refs.list.loadListObj({
                url: 'cmp.proj.graph'
            })
        },
        computed: {
            ...mapGetters(['getListObj'])
        },
    }
</script>

<style lang="stylus" scoped>

</style>
